/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S7_SuffixInputs */

const tr_cerez_s7_suffix = /** @type {(inputs: Cerez_S7_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sayfalarımızı inceleyebilirsiniz.`)
};

const en_cerez_s7_suffix = /** @type {(inputs: Cerez_S7_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pages.`)
};

const de_cerez_s7_suffix = /** @type {(inputs: Cerez_S7_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entnehmen.`)
};

const ru_cerez_s7_suffix = /** @type {(inputs: Cerez_S7_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`нашего сайта.`)
};

/**
* | output |
* | --- |
* | "pages." |
*
* @param {Cerez_S7_SuffixInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s7_suffix = /** @type {((inputs?: Cerez_S7_SuffixInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S7_SuffixInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s7_suffix(inputs)
	if (locale === "de") return de_cerez_s7_suffix(inputs)
	if (locale === "ru") return ru_cerez_s7_suffix(inputs)
	return tr_cerez_s7_suffix(inputs)
});